
const Copy = ({ width }) => {

    return <svg style={{ width: width }} xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none" >
        <g clipPath="url(#clip0_7975_31632)">
            <path d="M13.4121 6.75018H7.78711C7.09675 6.75018 6.53711 7.42176 6.53711 8.25018V15.0002C6.53711 15.8286 7.09675 16.5002 7.78711 16.5002H13.4121C14.1025 16.5002 14.6621 15.8286 14.6621 15.0002V8.25018C14.6621 7.42176 14.1025 6.75018 13.4121 6.75018Z" stroke="#636363" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.03711 11.2502H3.41211C3.08059 11.2502 2.76265 11.0921 2.52823 10.8108C2.29381 10.5295 2.16211 10.148 2.16211 9.75018V3.00018C2.16211 2.60236 2.29381 2.22083 2.52823 1.93952C2.76265 1.65822 3.08059 1.50018 3.41211 1.50018H9.03711C9.36863 1.50018 9.68657 1.65822 9.92099 1.93952C10.1554 2.22083 10.2871 2.60236 10.2871 3.00018V3.75018" stroke="#636363" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_7975_31632">
                <rect width="15" height="18" fill="white" transform="translate(0.912109 0.000183105)" />
            </clipPath>
        </defs>
    </svg>


}
export default Copy;